import { Table, TableRow, TableCell, Paragraph, TextRun, WidthType, BorderStyle, AlignmentType, TableLayoutType } from 'docx';
import { BORDER_COLOR, HEADER_FILL_COLOR } from './constants';
import { formatDate, DEFAULT_CONTENT_WIDTH, equalWidths } from './utils';
import { parseHtmlContent } from './htmlParser';

export const createSummaryTable = (summary, contentWidth = DEFAULT_CONTENT_WIDTH) => {
	if (!summary || typeof summary !== 'object') {
		console.warn('Geçersiz özet bilgisi:', summary);
		return createEmptyTable('Özet bilgisi mevcut değil', contentWidth);
	}

	const isOzet = summary.type === 'özet';
	let leftHeader, rightHeader;

	if (isOzet) {
		// Eğer kategori "Diğer" ise ve customCategory varsa, onu kullan
		leftHeader = summary.category === 'Diğer' && summary.customCategory
			? summary.customCategory
			: summary.category;
		rightHeader = formatDate(summary.date);
	} else {
		// Burada summary.type'ı kullanarak doğru kategoriyi belirliyoruz
		let category;
		switch(summary.type) {
			case 'sanık':
				category = 'Sanık';
				break;
			case 'mağdur':
				category = 'Mağdur';
				break;
			case 'tanık':
				category = 'Tanık';
				break;
			default:
				category = summary.category;
		}
		leftHeader = `${category} ${summary.name}`;
		rightHeader = `${summary.stage} Beyanı (${formatDate(summary.date)})`;
	}

	const cols = equalWidths(contentWidth, 2);
	return new Table({
		width: { size: contentWidth, type: WidthType.DXA },
		layout: TableLayoutType.FIXED,
		columnWidths: cols,
		borders: {
			top: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
			bottom: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
			left: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
			right: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
			insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
			insideVertical: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
		},
		rows: [
			new TableRow({
				children: [
					new TableCell({
						children: [new Paragraph({
							children: [new TextRun({
								text: leftHeader,
								bold: true,
							})],
							alignment: AlignmentType.LEFT,
						})],
						width: { size: cols[0], type: WidthType.DXA },
						margins: {
							left: 100,
							right: 100,
						},
						shading: {
							fill: HEADER_FILL_COLOR,
						},
					}),
					new TableCell({
						children: [new Paragraph({
							children: [new TextRun({
								text: rightHeader,
								bold: true,
							})],
							alignment: AlignmentType.RIGHT,
						})],
						width: { size: cols[1], type: WidthType.DXA },
						margins: {
							left: 100,
							right: 100,
						},
						shading: {
							fill: HEADER_FILL_COLOR,
						},
					}),
				],
			}),
			new TableRow({
				children: [
					new TableCell({
						children: parseHtmlContent(summary.content),
						columnSpan: 2,
						margins: {
							top: 100,
							bottom: 100,
							left: 100,
							right: 100,
						},
					}),
				],
			}),
		],
	});
};

function createEmptyTable(message, contentWidth = DEFAULT_CONTENT_WIDTH) {
  return new Table({
    width: { size: contentWidth, type: WidthType.DXA },
    layout: TableLayoutType.FIXED,
    columnWidths: [contentWidth],
    rows: [new TableRow({
      children: [new TableCell({
        width: { size: contentWidth, type: WidthType.DXA },
        children: [new Paragraph({ text: message })],
      })],
    })],
  });
}